import React from 'react';
import { PostHogProvider } from 'posthog-js/react';

interface Props {
  children: React.ReactNode;
  client: any;
}

export function PostHogProviderWrapper({ children, client }: Props) {
  if (import.meta.env.VITE_DISABLE_POSTHOG === 'true') {
    return <>{children}</>;
  }
  return <PostHogProvider client={client}>{children}</PostHogProvider>;
}
